module.exports = __webpack_public_path__ + "static/media/normal.82da13f5.svg";